export default {
  data() {
    return {
      searchTitle: '',
      hospital800InformationTableHeaders: [
        { text: 'ردیف', value: 'count', align: 'center' },
        { text: 'نام بیمارستان', value: 'hospital', align: 'center' },
        { text: 'شماره تماس', value: 'phoneNumber', align: 'center' },
        { text: 'تعداد پذیرش جاری', value: 'admissionCount', align: 'center' },
        {
          text: 'تعداد پذیرش 24 ساعت اخیر',
          value: 'admissionCount24',
          align: 'center',
        },
      ],
      hospital800List: [],
      hospitalPhoneNumbers: [],
      rightClickItems: [
        {
          title: 'تماس با بیمارستان',
          icon: 'mdi-phone-log mdi-flip-h mdi-18px',
        },
      ],
      showMenu: false,
      x: 0,
      y: 0,
      closeOnContentClick: false,
    };
  },
  methods: {
    readyData: function (data) {
      this.hospital800List = [];
      for (let i = 0; i < data.length; i++) {
        let hospitalPhoneNumbers = [];
        if (data[i].phoneNumber) {
          let temp = data[i].phoneNumber.split(',');
          for (let j = 0; j < temp.length; j++) {
            if (temp[j] && temp[j] != ',') {
              hospitalPhoneNumbers.push(temp[j]);
            }
          }
        }
        this.hospital800List.push({
          id: data[i].id,
          hospital: data[i].title ? data[i].title : '-',
          phoneNumber: data[i].phoneNumber ? data[i].phoneNumber : '-',
          admissionCount: data[i].recentAdmissionCount ? data[i].recentAdmissionCount : '0',
          admissionCount24: data[i].last24HoursAdmissionCount
            ? data[i].last24HoursAdmissionCount
            : '0',
          count: i + 1,
          hospitalPhoneNumbers: hospitalPhoneNumbers,
        });
      }
    },
    rightClickHandler(e, data) {
      e.preventDefault();
      this.hospitalPhoneNumbers = data.item.hospitalPhoneNumbers;
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    rightClickAction: function (type, to) {
      this.showMenu = false;
      if (type == 'تماس با بیمارستان') {
        if (to) {
          let data = {
            missionPhoneId: null,
            missionId: null,
            to: to,
          };
          this.callToHospitalFunction(data);
          this.showMenu = false;
        } else {
          this.snackText = 'بیمارستان شماره ثبت شده ای ندارد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
    },
  },
};
